import { SubjectCreate } from './SubjectCreate';
import { SubjectEdit } from './SubjectEdit';
import { SubjectList } from './SubjectList';

export default {
    create: SubjectCreate,
    edit: SubjectEdit,
    list: SubjectList
}